export const OKTA_RESOURCE_SET = "P0 All Users and Groups";
export const OKTA_CUSTOM_ROLE = "P0 Directory Lister";
